import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module20World.css';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from '../../Unit4/Module20/Apple/ApplePractice.js';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule10 from '../../FollowTheBeat/FollowTheBeatModule10.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';

const Module20World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module20 } = useSelector((state) => state.module20, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module20Images/Unit4_Mod5BG-01.png');
  const animal = generateImageUrl('images/Module5Images/Bird+Closing+still.gif');
  const nest = generateImageUrl('images/Module20Images/Nest.svg');
  let progressbar0 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_0.svg");
  let progressbar1 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_Third.svg");
  let progressbar2 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_2Thirds.svg");
  let progressbar3 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_2Thirds.svg");
  let progressbarCompleted = generateImageUrl("images/Module5Images/Mod5_ProgressBar_Completed.svg");
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module5Images/Worm.png');
  const Egg = generateImageUrl('images/Module5Images/Egg.png');
  const eggBottom = generateImageUrl('images/Module5Images/Egg+Crack+Bottom.png');
  const eggTop = generateImageUrl('images/Module5Images/Egg+Crack+Top.png');
  const Tree = generateImageUrl('images/Module15Images/Tree.png');
  const LamppostGreen = generateImageUrl('images/Module20Images/U4_M5_DailyReward_Lamp1@3x.png');
  const LamppostBlue = generateImageUrl('images/Module20Images/U4_M5_DailyReward_Lamp2@3x.png');
  const StandPear = generateImageUrl('images/Module20Images/StandPear.png');
  const StandApple = generateImageUrl('images/Module20Images/StandApple.png');
  const CarRed = generateImageUrl('images/Module20Images/CarRed.png');
  const ScooterBlue = generateImageUrl('images/Module20Images/ScooterBlue.png');
  const CometOrange = generateImageUrl('images/Module20Images/CometOrange.png');
  const CometBlue = generateImageUrl('images/Module10Images/DailyReward_CometBlue.png');
  const BirdHaircutMohawk = generateImageUrl('images/Module20Images/BirdHaircutMohawk.png');
  const BirdHaircutEmo = generateImageUrl('images/Module20Images/BirdHaircutEmo.png');
  const Goggles = generateImageUrl('images/Module20Images/Goggles.png');
  const Helmet2 = generateImageUrl('images/Module20Images/Helmet2.png');
  const BakeryStoreGreen = generateImageUrl('images/Module20Images/U4_M5_DailyReward_Bakery1@3x.png');
  const BakeryStoreRed = generateImageUrl('images/Module20Images/U4_M5_DailyReward_Bakery2@3x.png');
  const PopcornRed = generateImageUrl('images/Module20Images/PopcornRed.png');
  const PopcornBlue = generateImageUrl('images/Module20Images/PopcornBlue.png');
  const BirdDress = generateImageUrl('images/Module20Images/Coin_BirdDress.png');
  const BirdHoodie = generateImageUrl('images/Module20Images/Coin_BirdHoddie.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'appfiles/caring/closing.mp4';
  const present = generateImageUrl('images/Images/Gift.png');
  const eggCrackAudio = new Audio(generateImageUrl('media/Module5Videos/egg_crack.mp3'));
  const eggHalfCracked = generateImageUrl('images/Module5Images/EggCrack_3.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [eggAnimate, setEggAnimate] = useState(false);
  const [eggAnimationState, setEggAnimationState] = useState('');

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayFTB, setDisplayFTB] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [practice, setPractice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');

  const [keyState, setKeyState] = useState('');
  const [eggHalf, setEggHalf] = useState(false);
  const [eggState, setEggState] = useState(Egg);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [specialMessage, setSpecialMessage] = useState(false);
  const [watchConversation, setWatchConversation] = useState(false);
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [animalClose, setAnimalClose] = useState(false);
  const [playAnimalClose, setPlayAnimalClose] = useState(false);
  const [animalCloseAudio, setAnimalCloseAudio] = useState(false);
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [amazingJob, setAmazingJob] = useState(false);
  const [amazingJobAudio, setAmazingJobAudio] = useState(false);
  const [showReward, setShowReward] = useState(false);

  let [ftbMusic, setFTBMusic] = useState("");
  let [ftbInstruction, setFTBInstruction] = useState("");
  let [ftbInstructionGIF, setFTBInstructionGIF] = useState("");
  let [ftbCount, setFTBCount] = useState("");
  let [ftbTutorial1, setFTBTutorial1] = useState("");
  const [ftbTutorial1_2, setFTBTutorial1_2] = useState('');
  let [ftbTutorial2, setFTBTutorial2] = useState("");
  let [ftbWT, setFTBWalkThrough] = useState("");

  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getGifs() {
    setSpecialMessage(getVideo('appfiles/close/practice special message.gif', login));
    setWatchConversation(getVideo('appfiles/close/practice watch conversation.gif', login));
    setAmazingJobAudio(getVideo('appfiles/close/close_awesome_job.mp3', login));
    setAmazingJob(getVideo('appfiles/close/awesome job.gif', login));
    setPracticeIntro(getVideo('appfiles/caring/caring_practice_intro.gif', login));
    setLearnIntro(getVideo('appfiles/caring/caring_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/close/ftb intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/close/close_celebrate_intro.gif', login));
    setAnimalClose(getVideo('appfiles/caring/caring_closing.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/caring/caring_day_finished.mp3', login));
    setFTBInstruction(getVideo('appfiles/caring/caring_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/close/FTB intructions.gif', login));
    setFTBMusic(getVideo('appfiles/close/close_ftb_audio.m4a', login));
    setFTBCount(getVideo('appfiles/close/countingBird.gif', login));

    if (!module20.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/caring/ftb_walkthrough_touch_right_foot.mp3', login));
      setFTBTutorial1_2(getVideo('appfiles/caring/ftb_walkthrough_touch_left_foot.mp3', login));
      setFTBTutorial2(getVideo('appfiles/manners/ftb_walkthrough_together.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/close/ftb_walkthrough_audio.mp3', login));
    }
  }

  useEffect(() => {
    getGifs();
  }, []);

  // Device detection functions
  const isIPhone = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPhoneUserAgent = /iphone/.test(userAgent);
    const isSmallScreenTouch = window.innerWidth < 768 && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    
    return isIPhoneUserAgent || isSmallScreenTouch;
  };

  const isIPad = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPadUserAgent = /ipad/.test(userAgent) || (/macintosh/.test(userAgent) && 'ontouchend' in document);
    const isTabletScreenSize = window.innerWidth >= 768 && window.innerWidth <= 1024;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    return isIPadUserAgent || (isTabletScreenSize && isTouchDevice);
  };

  const createGameDetails = (flag, reward, coin) => {
    const game_detail = module20.game_details;
    if (flag) {
      const flags = { flag, lastUpdated: new Date().toJSON() };
      game_detail.moduleFlags.psuh(flags);
    }
    if (coin >= 0) {
      game_detail.tokens_earned = coin;
    }
    if (reward) {
      const dailyRewards = [];
      for (const key in module20.rewards) {
        if (module20.rewards[key].unlocked === true) {
          const rewards = {
            type: key,
            x_multiplier: module20.rewards[key].x,
            y_multiplier: module20.rewards[key].y,
          };
          dailyRewards.push(rewards);
        }
      }
      game_detail.dailyRewards = dailyRewards;
    }
    dispatch({ type: 'MODULE20_SET_GameDetials', payload: game_detail });
  };

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "Caring",
				day_completed: module20.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = async () => {
    const myInit = {
      body: {
        id: module20.moduleID,
        day_completed: module20.day_completed,
        step_completed: module20.stepCompleted,
        game_details: JSON.stringify(module20.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setShowAnimal(true);
          setPlayAnimalClose(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          module20.stepCompleted === 'notstarted' ||
          module20.stepCompleted === 'learn' ||
          module20.stepCompleted === 'practice' ||
          module20.stepCompleted === 'celebrate' ||
          module20.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'Caring',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module20.stepCompleted]);

    useEffect(() => {
      if((module20.reviewIcon === true || login.grade === "Teacher Mode") && module20.sectionCompleted === 4 ) {
          updateProgress();
          module20.sectionCompleted = 0;
      }
    }, [module20.sectionCompleted])

  useEffect(() => {
    if (module20.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module20.coins);
      updateDB();
    }
  }, [module20.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module20.currentday <= module20.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE20_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE20_SET_KEY', payload: 4 });
      if (module20.currentday === 4 || module20.currentday === 8) {
        dispatch({ type: 'MODULE20_SET_KEY', payload: 5 });
      }
    } else {
      if (module20.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE20_TOGGLE_REVIEW_ICON', payload: false });
      if (module20.currentday === 4 && module20.day_completed === 3) {
        if (module20.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 0 });
        } else if (module20.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 1 });
        } else if (module20.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 2 });
        } else if (module20.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 3 });
        } else if (module20.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 4 });
        } else if (module20.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE20_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module20.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 0 });
        } else if (module20.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 1 });
        } else if (module20.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 2 });
        } else if (module20.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 3 });
        } else if (module20.stepCompleted === 'celebrate') {
          if (module20.currentday === 8 && module20.day_completed === 7) {
            dispatch({ type: 'MODULE20_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE20_SET_KEY', payload: 4 });
          }
        } else if (module20.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE20_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module20.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);
  let [displayRewardVideo, setDisplayRewardVideo] = useState(false);
  let [rewardVideo, setRewardVideo] = useState('');

  const selectReward = () => {
    return (
      <>
        <div className='rewards'  id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE20_SET_REWARD${module20.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE20_SET_REWARD${module20.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE20_SET_REWARD${module20.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE20_SET_REWARD${module20.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE20_SET_DAY_UNLOCK${module20.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE20_SET_dayCompleted',
                    payload: module20.currentday === 8 ? 9 : module20.currentday,
                  });
                  dispatch({
                    type: 'MODULE20_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              onError={() => {
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  dispatch({
                    type: `MODULE20_SET_DAY_UNLOCK${module20.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE20_SET_dayCompleted',
                    payload: module20.currentday === 8 ? 9 : module20.currentday,
                  });
                  dispatch({
                    type: 'MODULE20_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                let name = '';
                switch (module20.currentday){
                  case 1:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_LampPost 1.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_LampPost 2.mp4'
                    }
                    break;
                  case 2:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_ShootingStar 1.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_ShootingStar 2.mp4'
                    }
                    break;
                  case 3:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_Veichle 1.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_Veichle 2.mp4'
                    }
                    break;
                  case 4:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_FoodStand 2.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_FoodStand 1.mp4'
                    }
                    break;
                  case 5:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_Haircut 1.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_Haircut 2.mp4'
                    }
                    break;
                  case 6:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_Clothing 1.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_Clothing 2.mp4'
                    }
                    break;
                  case 7:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_Bakery 1.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_Bakery 2.mp4'
                    }
                    break;
                  case 8:
                    if (document.getElementById('rewardItemLeft2').style.borderColor === 'yellow'){
                      name = 'media/Module20/Unit4_Mod5_Movie 1.mp4'
                    }
                    else{
                      name = 'media/Module20/Unit4_Mod5_Movie 2.mp4'
                    }
                    break;
                }
                setRewardVideo(generateImageUrl(name))
                document.getElementById('rewardItemLeft2').style.display = 'none'
                document.getElementById('rewardItemRight2').style.display = 'none'
                setDisplayRewardVideo(true);
              }} 
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={BirdDress}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE20_SET_PRIZE1`, payload: true });
                dispatch({ type: `MODULE20_SET_PRIZE2`, payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={BirdHoodie}
              alt=''
              onClick={() => {
                dispatch({ type: `MODULE20_SET_PRIZE2`, payload: true });
                dispatch({ type: `MODULE20_SET_PRIZE1`, payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {displayRewardVideo && (
          <video id='rewardVideo'
              autoPlay
              onEnded={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE20_SET_COIN',
                    payload: module20.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              onError={() => {
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE20_SET_COIN',
                    payload: module20.coins - 100,
                  });
                  setDisplayRewardVideo(false);
                });
              }}
              playsInline
            >
              <source src={rewardVideo} type='video/mp4'></source>
          </video>
        )}
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                if (document.getElementById('rewardItemLeft').style.borderColor === 'yellow'){
                  setRewardVideo(generateImageUrl('media/Module20/Unit4_Mod5_SpecialReward 2.mp4'))
                }
                else{
                  setRewardVideo(generateImageUrl('media/Module20/Unit4_Mod5_SpecialReward 1.mp4'))
                }
                document.getElementById('rewardItemLeft').style.display = 'none'
                document.getElementById('rewardItemRight').style.display = 'none'
                setDisplayRewardVideo(true);
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module20.currentday) {
      case 1:
        setRewardOption1(LamppostGreen);
        setRewardOption2(LamppostBlue);
        break;
      case 2:
        setRewardOption1(CometBlue);
        setRewardOption2(CometOrange);
        break;
      case 3:
        setRewardOption1(CarRed);
        setRewardOption2(ScooterBlue);
        break;
      case 4:
        setRewardOption1(StandPear);
        setRewardOption2(StandApple);
        break;
      case 5:
        setRewardOption1(BirdHaircutMohawk);
        setRewardOption2(BirdHaircutEmo);
        break;
      case 6:
        setRewardOption1(Goggles);
        setRewardOption2(Helmet2);
        break;
      case 7:
        setRewardOption1(BakeryStoreGreen);
        setRewardOption2(BakeryStoreRed);
        break;
      case 8:
        setRewardOption1(PopcornRed);
        setRewardOption2(PopcornBlue);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [keyIcon]);

  const displayReview = () => {
    if (module20.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/caring/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module20.currentday === 4) {
              dispatch({ type: 'MODULE20_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module20.day_completed === 9) {
              navigate('/caring/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/caring/caring_demo.m4a', login);
    let video = getVideo('appfiles/caring/learn_video.mp4', login);
    switch (module20.currentday) {
      case 1:
        setLearn(
          <Learn
            video='appfiles/caring/learn_day_1.mp4'
            songVideo={video}
            closingVideo='appfiles/caring/learn_day_1_closing.mp4'
            destiny='/caring'
            song={song}
            back='/caring'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE20_SET_stepCompleted'
            module={module20}
            module20={true}
            animal={generateImageUrl('images/module20Images/practice/Bird.png')}
            learnVideo1={'appfiles/caring/learn_day_1_step_1.mp4'}
            learnVideo2={'appfiles/caring/learn_day_1_step_2.mp4'}
            learnVideo3={'appfiles/caring/learn_day_1_step_3.mp4'}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='appfiles/caring/learn_day_2.mp4'
            songVideo={video}
            closingVideo='appfiles/caring/learn_day_2_closing.mp4'
            destiny='/caring'
            song={song}
            back='/caring'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE20_SET_stepCompleted'
            module={module20}
            module20={true}
            animal={generateImageUrl('images/module20Images/practice/Bird.png')}
            learnVideo1={'appfiles/caring/learn_day_2_step_1.mp4'}
            learnVideo2={'appfiles/caring/learn_day_2_step_2.mp4'}
            learnVideo3={'appfiles/caring/learn_day_2_step_3.mp4'}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='appfiles/caring/learn_day_2.mp4'
            songVideo={video}
            closingVideo='appfiles/caring/learn_day_3_closing.mp4'
            destiny='/caring'
            song={song}
            back='/caring'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE20_SET_stepCompleted'
            module={module20}
            module20={true}
            animal={generateImageUrl('images/module20Images/practice/Bird.png')}
            learnVideo1={'appfiles/caring/learn_day_3_step_1.mp4'}
            learnVideo2={'appfiles/caring/learn_day_3_step_2.mp4'}
            learnVideo3={'appfiles/caring/learn_day_3_step_3.mp4'}
          />
        );
        break;
      default:
        setAnimalVoice(getVideo('appfiles/caring/caring_learn_intro.mp3', login));
        setDisplayVoice(true);
        setAnimalState(learnIntro);
        setShowAnimal(true);
        await GetUserVideo(`userfiles/${module20.StudentID}/caring_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module20.currentday - 4]}/close_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/caring'
                    song={data}
                    back='/caring'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE20_SET_stepCompleted'
                    module={module20}
                    instrumental={getVideo('appfiles/caring/caring_final.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/caring'
                    song={song}
                    back='/caring'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE20_SET_stepCompleted'
                    module={module20}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          })
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    const names = [
      [
        'caring_practice_1_5.mp4',
        'caring_practice_2_5.mp4',
        'caring_practice_3_5.mp4',
        'caring_practice_4_5.mp4',
      ],
      [
        'caring_practice_1_6.mp4',
        'caring_practice_2_6.mp4',
        'caring_practice_3_6.mp4',
        'caring_practice_4_6.mp4',
      ],
      [
        'caring_practice_1_7.mp4',
        'caring_practice_2_7.mp4',
        'caring_practice_3_7.mp4',
        'caring_practice_4_7.mp4',
      ],
      [
        'caring_practice_1_8.mp4',
        'caring_practice_2_8.mp4',
        'caring_practice_3_8.mp4',
        'caring_practice_4_8.mp4',
      ],
      [
        'caring_practice_1_9.mp4',
        'caring_practice_2_9.mp4',
        'caring_practice_3_9.mp4',
        'caring_practice_4_9.mp4',
      ],
    ];
    const instructions = [
      [
        'appfiles/caring/practice_grocery_1.mp4',
        'appfiles/caring/practice_grocery_2.mp4',
        'appfiles/caring/practice_grocery_3.mp4',
        'appfiles/caring/practice_grocery_4.mp4',
        'appfiles/caring/practice_grocery_5.mp4',
      ],
      [
        'appfiles/caring/practice_hair_1.mp4',
        'appfiles/caring/practice_hair_2.mp4',
        'appfiles/caring/practice_hair_3.mp4',
        'appfiles/caring/practice_hair_4.mp4',
      ],
      [
        'appfiles/caring/practice_clothing_1.mp4',
        'appfiles/caring/practice_clothing_2.mp4',
        'appfiles/caring/practice_clothing_3.mp4',
        'appfiles/caring/practice_clothing_4.mp4',
      ],
      [
        'appfiles/caring/practice_baker_1.mp4',
        'appfiles/caring/practice_baker_2.mp4',
        'appfiles/caring/practice_baker_3.mp4',
        'appfiles/caring/practice_baker_4.mp4',
      ],
      [
        'appfiles/caring/practice_movie_1.mp4',
        'appfiles/caring/practice_movie_2.mp4',
        'appfiles/caring/practice_movie_3.mp4',
        'appfiles/caring/practice_movie_4.mp4',
      ]
    ];
    const texts = [
      [
        `Press record and say, "I am good, thanks."`,
        `Press record and say, "A pack of gum, please."`,
        `Press record and say, "Here you go."`,
        `Press record and say, "You're welcome. See you later!"`,
      ],
      [
        `Press record and say, "Hello!"`,
        `Press record and say, "You do a great job!"`,
        `Press record and say, "You're welcome."`,
        `Press record and say, "Goodbye."`,
      ],
      [
        `Press record and say, "It is nice to meet you!"`,
        `Press record and say, "Can you help me find the socks, please?"`,
        `Press record and say, "Thank you very much!"`,
        `Press record and say, "Bye!"`,
      ],
      [
        `Press record and say, "Hello!"`,
        `Press record and say your favorite flavor.`,
        `Press record and say, "Awesome!"`,
        `Press record and say, "Goodbye!"`,
      ],
      [
        `Press record and say, "I am good! Thank you!"`,
        `Press record and say, "Here you go."`,
        `Press record and say, "That's great! Thanks!"`,
        `Press record and say, "See ya!"`,
      ],
    ];
    const voices = [
      [
        'appfiles/caring/practice_record_grocery_1.mp3',
        'appfiles/caring/practice_record_grocery_2.mp3',
        'appfiles/caring/practice_record_grocery_3.mp3',
        'appfiles/caring/practice_record_grocery_4.mp3',
      ],
      [
        'appfiles/caring/practice_record_baker_1.mp3',
        'appfiles/caring/practice_record_hair_1.mp3',
        'appfiles/caring/practice_record_hair_2.mp3',
        'appfiles/caring/practice_record_hair_3.mp3',
      ],
      [
        'appfiles/caring/practice_record_clothing_1.mp3',
        'appfiles/caring/practice_record_clothing_2.mp3',
        'appfiles/caring/practice_record_clothing_3.mp3',
        'appfiles/caring/practice_record_clothing_4.mp3',
      ],
      [
        'appfiles/caring/practice_record_baker_1.mp3',
        'appfiles/caring/practice_record_baker_2.mp3',
        'appfiles/caring/practice_record_baker_3.m4a',
        'appfiles/caring/practice_record_baker_4.m4a',
      ],
      [
        'appfiles/caring/practice_record_movie_1.mp3',
        'appfiles/caring/practice_record_movie_2.mp3',
        'appfiles/caring/practice_record_movie_3.mp3',
        'appfiles/caring/practice_record_movie_4.mp3',
      ]
    ];

    const exampleVideos = [
      '4b742312947d83473d21f6888019/480.m3u8',
      'f8e52e21ea4561a78d5c38967804/480.m3u8',
      'debc60bcaf698b2ac158fd60ca8b/480.m3u8',
      'Module20/day4_practice_conversation.mp4',
      'Module20/day8_practice_conversation.mp4',
    ];
    
    const bgs = ['images/Module20Images/practice/GroceryChromebook.png',
        'images/newDesign/Unit4Module20/Salon/background/SalonBGLarge_new.png',
        'images/newDesign/Unit4Module20/Clothing/background/ClothingBGLarge.png',
        'images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGClosed.png',
        'images/newDesign/Unit4Module20/Cinema/background/CinemaBGLarge.png',
      ]
    const bgs_original = ['images/Module20Images/practice/GroceryChromebook.png',
      'images/Module20Images/practice/Salon_Chromebook.png',
      'images/Module20Images/practice/Clothing_Chromebook.png',
      'images/Module20Images/practice/Bakery_Chromebook.png',
      'images/Module20Images/practice/Cinema_Chromebook.png',
      ]
    const bgs_phone = ['images/Module20Images/practice/GroceryPhone.png',
      'images/newDesign/Unit4Module20/Salon/background/SalonBGLarge_new.png',
      'images/Module20Images/practice/Clothing_Phone_4.png',
      'images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGClosed.png',
      'images/Module20Images/practice/Cinema_Chromebook.png',
    ]
    const bgs_ipad = ['images/Module20Images/practice/U4M5_Background_GroceryStore.png',
      'images/newDesign/Unit4Module20/Salon/background/SalonBGMedium_new.png',
      'images/newDesign/Unit4Module20/Clothing/background/ClothingBGMedium_new.png',
      'images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGClosed.png',
      'images/Module20Images/practice/U4M5_Practice_BG_Theater.png',
    ]
    let voice1 = getVideo('appfiles/close/close_practice_watch_conversation.mp3', login);
    let voice2 = getVideo('appfiles/close/close_awesome_job.mp3', login);
    switch (module20.currentday) {
      case 1:
        setPractice(
          <Practice
            video1={'appfiles/caring/practice_day_1.mp4'}
            video2={'appfiles/caring/practice_day_1_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE20_SET_stepCompleted'}
            module={module20}
            animal={animal}
            conversationGIF={watchConversation}
            conversationAudio={voice1}
            endAudio={voice2}
            endGIF={amazingJob}
          />
        );
        break;
      case 2:
        setPractice(
          <Practice
            video1={'appfiles/caring/practice_day_2.mp4'}
            video2={'appfiles/caring/practice_day_2_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE20_SET_stepCompleted'}
            module={module20}
            animal={animal}
            conversationGIF={watchConversation}
            conversationAudio={voice1}
            endAudio={voice2}
            endGIF={amazingJob}
          />
        );
        break;
      case 3:
        setPractice(
          <Practice
            video1={'appfiles/caring/practice_day_3.mp4'}
            video2={'appfiles/caring/practice_day_3_review.mp4'}
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE20_SET_stepCompleted'}
            module={module20}
            animal={animal}
            conversationGIF={watchConversation}
            conversationAudio={voice1}
            endAudio={voice2}
            endGIF={amazingJob}
          />
        );
        break;
        default:
          setAnimalVoice(getVideo('appfiles/caring/caring_practice_intro.mp3', login));
          setDisplayVoice(true);
          setAnimalState(practiceIntro);
          setShowAnimal(true);
          setPractice(
            <Practice
              day4={true}
              setDisplayPractice={setDisplayPractice}
              background={isIPhone() ? generateImageUrl(bgs_phone[module20.currentday - 4]) : isIPad() ? generateImageUrl(bgs_ipad[module20.currentday - 4]) : generateImageUrl(bgs[module20.currentday - 4])}
              background1={generateImageUrl(bgs_original[module20.currentday - 4])}
              stepComplete={'MODULE20_SET_stepCompleted'}
              module={module20}
              animal={animal}
              introduction={practiceIntro}
              conversationGIF={watchConversation}
              conversationAudio={voice1}
              practiceMessage={specialMessage}
              practiceConversation={watchConversation}
              endAudio={voice2}
              endGIF={amazingJob}
              awesomeJob={amazingJob}
              instructions={instructions[module20.currentday - 4]}
              names={names[module20.currentday - 4]}
              texts={texts[module20.currentday - 4]}
              voices={voices[module20.currentday - 4]}
              influencerid={influencers[module20.currentday - 4]}
              exampleVideo={exampleVideos[module20.currentday - 4]}
            />
        );
        break;
    }
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    setAnimalVoice(getVideo('appfiles/close/close_ftb_intro.mp3', login));
    setDisplayVoice(true);
    setAnimalState(ftbIntro);
    setShowAnimal(true);
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = 'appfiles/caring/celebrate_day_1.mp4';
    const celebrateVideo2 = 'appfiles/caring/celebrate_day_2.mp4';
    const celebrateVideo3 = 'appfiles/caring/celebrate_day_3.mp4';

    switch (module20.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module20}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE20'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module20}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE20'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module20}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE20'}
          />
        );
        break;
      default:
        let audios = ['appfiles/caring/caring_celebrate_record_take_care_myself.mp3',
        'appfiles/caring/caring_celebrate_record_take_care_others.mp3',
        'appfiles/caring/caring_celebrate_record_take_care_world.mp3',
        'appfiles/caring/caring_celebrate_record_see_fix.mp3',
        'appfiles/caring/caring_celebrate_record_hard_things.mp3']
        let text = [`Record yourself in an excited voice and say, "I believe in me because I take care of myself!"`,
        `Record yourself in an excited voice and say, "I believe in me because I take care of others!"`,
        `Record yourself in an excited voice and say, "I believe in me, because I take care of the world!"`,
        `Record yourself in an excited voice and say, "I believe in me, because I can see it, fix it and make it even better!"`,
        `Record yourself in an excited voice and say, "I believe in me, because I can do hard things!"`]
        setAnimalVoice(getVideo('appfiles/close/close_celebrate_intro.mp3', login));
        setDisplayVoice(true);
        setAnimalState(celebrateIntro);
        setShowAnimal(true);
        let voice1 = getVideo(audios[module20.currentday-4], login);
        let voice2 = getVideo('appfiles/close/close_celebrate_say_believe.mp3', login);
        let voice3 = getVideo('appfiles/close/close_awesome_job.mp3', login);
        let animalGIF = getVideo('appfiles/active_listening/joyful jingle bird.gif', login);
        let animalVoice = getVideo('appfiles/active_listening/active_listening_joyful_jingle_intro.mp3', login);
        await GetUserVideo(`influencers/${influencers[module20.currentday - 4]}/close_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              world3={true}
              module={module20}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={text[module20.currentday-4]}
              name={`caring_celebration_surprise_${
                module20.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE20'}
              bigAnimal={true}
            />
          );
        })
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = 'appfiles/caring/singing_time.mp4';
    let noteVideo = getVideo('appfiles/caring/caring_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/caring/caring_demo.m4a', login);
    let instrumental = getVideo('appfiles/caring/caring_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module20}
        moduleNum='MODULE20'
        name='caring'
        instrumental={instrumental}
        instrumentalURL={'appfiles/caring/caring_final.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `userfiles/${module20.StudentID}/caring_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid}/close_affirmation.mp4`,
      },
      {
        video: 'appfiles/caring/practice_clothing_1.mp4',
      },
      {
        video: `userfiles/${module20.StudentID}/caring_practice_1_7.mp4`,
      },
      {
        video: 'appfiles/caring/practice_clothing_2.mp4',
      },
      {
        video: `userfiles/${module20.StudentID}/caring_practice_2_7.mp4`,
      },
      {
        video: 'appfiles/caring/practice_clothing_3.mp4',
      },
      {
        video: `userfiles/${module20.StudentID}/caring_practice_3_7.mp4`,
      },
      {
        video: 'appfiles/caring/practice_clothing_4.mp4',
      },
      {
        video: `userfiles/${module20.StudentID}/caring_practice_4_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/conversation_affirmation.mp4`,
      },
      {
        video: `userfiles/${module20.StudentID}/caring_celebration_surprise_6.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/close_affirmation.mp4`,
      },
      {
        video: `userfiles/${module20.StudentID}/caring_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/close_affirmation.mp4`,
      },
      {
        video: `userfiles/${module20.StudentID}/caring_celebration_surprise_8.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/close_affirmation.mp4`,
      },
      {
        video: `userfiles/${module20.StudentID}/caring_celebration_surprise_9.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; ++i){
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
  
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/caring/caring_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const eggAnimation = () => {
    setKeyState('fade-out');
    eggCrackAudio.play();
    setEggHalf(true);
    sleep(2000).then(() => {
      setEggHalf(false);
      setEggState(eggBottom);
      setEggAnimationState('eggAnimate');
      setEggAnimate(true);
      sleep(1500).then(() => {
        setRewardsFound(true);
        setDisplayReward(true);
        setKeyIcon(false);
      });
    });
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(getVideo(AfterCelebrateVideo9, login));
  };

  const playButtonAudio = () => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE20_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE20_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(displayVoice && isIOS()) {
      timer = setTimeout(() => {
        setDisplayVoice(false);
        setAnimalState('');
        setShowAnimal(false);
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayVoice]);

  useEffect(() => {
    let timer;
    if(playAnimalClose && isIOS()) {
      timer = setTimeout(() => {
        setPlayAnimalClose(false);
        if(module20.currentday === 8) {
          closeDay9Video();
        } else {
          navigate('/caring/navigation');
        }
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [playAnimalClose]);

  useEffect(() => {
    let timer;
    if(coinAudio && isIOS()) {
      timer = setTimeout(() => {
        dispatch({ type: 'MODULE20_SET_COIN', payload: module20.coins + 1 });
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [coinAudio]);


  return (
    <>
      {playAnimalClose && (
        <audio
          autoPlay
          onEnded={() => {
            setPlayAnimalClose(false);
            module20.currentday === 8
              ? closeDay9Video()
              : navigate('/caring/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE20_SET_COIN',
              payload: module20.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {displayVoice && (
        <audio
          autoPlay
          onEnded={() => {
            setDisplayVoice(false);
            setAnimalState('');
            setShowAnimal(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!displayVoice && displayLearn && learn}
      {!displayVoice && displayPractice && practice}
      {!displayVoice && displayFTB && (
        <FollowTheBeatModule10
          unit4={true} 
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJobAudio}
          awesomeJobGIF={amazingJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial1_2={ftbTutorial1_2}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE20_SET_stepCompleted'}
          module={module20}
          score={'ftb_caring'}
        />
      )}
      {!displayVoice && displayCelebrate && celebrate}
      {displaySingingTime && singTime}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        displayVoice) && (
        <div
          className='activeListeningWorldBody'
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world Image'
              onClick={() => {
                navigate('/caring/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                sleep(1400).then(() => {
                  sleep(1000).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <div className="Bird_Container">
            {showAnimal && (
              <img className="birdCharacterGif" src={animalState} alt='monkey Icon'/>
            )}
            <img
              className="birdCharacter"
              src={animal}
              alt="bird Icon"
            />
            <img className="Bird_Egg" src={eggState} alt="Egg Icon" />
            <img className="Bird_Nest" src={nest} alt="Egg Icon" />
            {eggHalf && (
              <img
                className="Bird_Egg"
                src={eggHalfCracked}
                id={"eggFade"}
                alt="Egg Icon"
              />
            )}
            {eggAnimate && (
              <img
                className="Bird_Egg"
                src={eggTop}
                id={eggAnimationState}
                alt="Egg Icon"
              />
            )}
          </div>

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'

            />
            {module20.coins < 10 && (
              <h5 className='scoretext1'>{module20.coins}</h5>
            )}
            {module20.coins >= 10 && module20.coins < 100 && (
              <h5 className='scoretext10'>{module20.coins}</h5>
            )}
            {module20.coins >= 100 && (
              <h5 className='scoretext100'>{module20.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module20.currentday === 4 || module20.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module20.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module20.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module20.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module20.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module20.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module20.currentday === 4 &&
                  module20.stepCompleted === 'notstarted' && (
                    <img
                      id='bounceIcons'
                      className='actionBtn2'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module20.currentday !== 4 &&
                  module20.stepCompleted === 'notstarted' && (
                    <img
                      id='bounceIcons'
                      className='actionBtn2'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module20.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    src={practiceBtn}
                    id='bounceIcons'
                    alt='practice button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}

                {module20.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    src={ftbBtn}
                    id='bounceIcons'
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}

                {module20.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    src={celebrateBtn}
                    id='bounceIcons'
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}

                {module20.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    src={learnBtn}
                    id='bounceIcons'
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module20.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
            (
              <div className='actionBtnDiv'>
                {module20.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setReviewIcon(!reviewIcon);
                  }}
                />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        eggAnimation();
                      });
                    }}
                />)}
                {module20.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon && keyIcon && !disPlayPrize && (
            <img
              className='rewardsIcon'
              id={keyState}
              style={{
                width: '150px',
                height: '40px',
                marginLeft: '-75px',
                zIndex: 10,
              }}
              src={keyReward}
              alt='reward key'
              onClick={() => {
                eggAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module20.rewards.LamppostGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.LamppostGreen.x * clientWidth,
                  y: module20.rewards.LamppostGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveLongReward1' if='LamppostGreen'
                  style={{ backgroundImage: `url(${LamppostGreen})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.LamppostBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.LamppostBlue.x * clientWidth,
                  y: module20.rewards.LamppostBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveLongReward2'
                  style={{ backgroundImage: `url(${LamppostBlue})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.StandPear.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.StandPear.x * clientWidth,
                  y: module20.rewards.StandPear.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveCart1'
                  style={{ backgroundImage: `url(${StandPear})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.StandApple.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.StandApple.x * clientWidth,
                  y: module20.rewards.StandApple.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveCart2'
                  style={{ backgroundImage: `url(${StandApple})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.CarRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.CarRed.x * clientWidth,
                  y: module20.rewards.CarRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveCarReward1'
                  style={{ backgroundImage: `url(${CarRed})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.ScooterBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.ScooterBlue.x * clientWidth,
                  y: module20.rewards.ScooterBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveCarReward2'
                  style={{ backgroundImage: `url(${ScooterBlue})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.CometBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.CometBlue.x * clientWidth,
                  y: module20.rewards.CometBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${CometBlue})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.CometOrange.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.CometOrange.x * clientWidth,
                  y: module20.rewards.CometOrange.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${CometOrange})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.BirdHaircutMohawk.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.BirdHaircutMohawk.x * clientWidth,
                  y: module20.rewards.BirdHaircutMohawk.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveCharaterReward1'
                  style={{ backgroundImage: `url(${BirdHaircutMohawk})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.BirdHaircutEmo.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.BirdHaircutEmo.x * clientWidth,
                  y: module20.rewards.BirdHaircutEmo.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveCharaterReward2'
                  style={{ backgroundImage: `url(${BirdHaircutEmo})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.Goggles.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.Goggles.x * clientWidth,
                  y: module20.rewards.Goggles.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='moveSmallReward1'
                  style={{ backgroundImage: `url(${Goggles})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.Helmet2.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.Helmet2.x * clientWidth,
                  y: module20.rewards.Helmet2.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='moveReward26'
                  style={{ backgroundImage: `url(${Helmet2})`}}
                ></div>
              </Draggable>
            )}

            {module20.rewards.BakeryStoreGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.BakeryStoreGreen.x * clientWidth,
                  y: module20.rewards.BakeryStoreGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveStore1'
                  style={{ backgroundImage: `url(${BakeryStoreGreen})`}}
                ></div>
              </Draggable>
            )}

            {module20.rewards.BakeryStoreRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.BakeryStoreRed.x * clientWidth,
                  y: module20.rewards.BakeryStoreRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveStore2'
                  style={{ backgroundImage: `url(${BakeryStoreRed})`}}
                ></div>
              </Draggable>
            )}

            {module20.rewards.PopcornRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.PopcornRed.x * clientWidth,
                  y: module20.rewards.PopcornRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='movePopcorn1'
                  style={{ backgroundImage: `url(${PopcornRed})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.PopcornBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.PopcornBlue.x * clientWidth,
                  y: module20.rewards.PopcornBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='movePopcorn2'
                  style={{ backgroundImage: `url(${PopcornBlue})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.BirdDress.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.BirdDress.x * clientWidth,
                  y: module20.rewards.BirdDress.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(1, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${BirdDress})` }}
                ></div>
              </Draggable>
            )}

            {module20.rewards.BirdHoodie.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module20.rewards.BirdHoodie.x * clientWidth,
                  y: module20.rewards.BirdHoodie.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(2, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${BirdHoodie})` }}
                ></div>
              </Draggable>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Module20World;
